import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ConfirmacionComponent } from 'src/app/home/confirmacion/confirmacion.component';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-alarma-detalle-dialog',
  templateUrl: './alarma-detalle-dialog.component.html',
  styleUrls: ['./alarma-detalle-dialog.component.scss']
})
export class AlarmaDetalleDialogComponent {

  comentario: string = '';
  zoomLevel: number = 1;

  zoomIn() {
    this.zoomLevel += 0.2;
  }

  zoomOut() {
    if (this.zoomLevel > 0.4) {
      this.zoomLevel -= 0.2;
    }
  }

  resetZoom() {
    this.zoomLevel = 1;
  }

  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AlarmaDetalleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private localsave: LocalSaveService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      comentario: [this.data.comentario_agente ? this.data.comentario_agente : '', Validators.required]
    });
  }

  cerrar() {
    this.dialogRef.close();
  }

  resolver(accion: number) {
    if (accion === 3) {
      this.dialogRef.close({
        accion,
        comentario: this.form.value.comentario
      });
    } else {
      const dialogRef = this.dialog.open(ConfirmacionComponent, {
        disableClose: true,
        width: '350px',
        data: { sms: `${accion === 1 ? 'APROBAR' : 'RECHAZAR'} la solicitud`, addcomment: false }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.resp) {
          this.dialogRef.close({
            accion,
            comentario: this.form.value.comentario
          });
        }
      });
    }
  }

  onClose() {
    this.dialogRef.close();
  }

}
